// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoComponent-module--video--39TTU"};